import React from "react";
import {
  FaShoppingCart,
  FaCheckCircle,
  FaTag,
  FaShieldAlt,
} from "react-icons/fa";

const ProductHighlights = () => {
  const featureData = [
    {
      icon: <FaShoppingCart size={24} color="#72AEC8" />,
      heading: "Swift Dispatch",
      text: "Lightning-fast order processing for quicker deliveries!",
    },
    {
      icon: <FaCheckCircle size={24} color="#72AEC8" />,
      heading: "Quality guarantee",
      text: "Premium products, tested and trusted for excellence",
    },
    {
      icon: <FaTag size={24} color="#72AEC8" />,
      heading: "Daily offers",
      text: "Daily discounts and special offers—shop & save!",
    },
    {
      icon: <FaShieldAlt size={24} color="#72AEC8" />,
      heading: "100% secure payment",
      text: "100% safe transactions with top-tier encryption.",
    },
  ];

  return (
    <div className="row">
      {featureData.map((item) => (
        <div className="col-lg-3 col-md-6 pb-3">
          <div className="icon-box d-flex">
            <div className="icon-box-icon pe-3 pb-3 pt-3">{item.icon}</div>
            <div className="icon-box-content">
              <h3
                className="text-uppercase "
                style={{ fontSize: "1.4em", color: "#000" }}
              >
                {item.heading}
              </h3>
              <p>{item.text}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductHighlights;
